import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from '@angular/router';

@Injectable()
export class AuthService {


  private token: string;
  tokenTimer: NodeJS.Timer;
  // public loginUser: LoginUser;
  // public jwtHelper: JwtHelperService = new JwtHelperService();

  /********************
   * STATIC ACCESS *****
   *********************/

  setAuthTimer(duration: number) {
    console.log("Setting timer: " + duration);
    this.tokenTimer = setTimeout(() => {
      this.logout();
    }, duration * 1000);
  }

  logout() {
    this.clearAuthData()
    clearTimeout(this.tokenTimer as unknown as number);
    this.route.navigateByUrl('/login');
  }

  private clearAuthData() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentRole');
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('currentCompany');
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    if (!authInformation) {
      return;
    }
    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
    if (expiresIn > 0) {
      this.setAuthTimer(expiresIn / 1000);
    }
  }

  private getAuthData() {
    const token = localStorage.getItem("token");
    const expirationDate = localStorage.getItem("expiration");
    if (!token || !expirationDate) {
      return;
    }
    return {
      token: token,
      expirationDate: new Date(expirationDate)
    }
  }

  // public static logout(): boolean {
  //   if (AuthService.isLoginFromGoogle()) {

  //     const googleLoginService = AppGlobal.injector.get(GoogleLoginService);
  //     const zone = AppGlobal.injector.get(NgZone);

  //     googleLoginService.logout(() => {
  //       zone.run(() => {
  //         return AuthService._logout();
  //       });
  //     });

  //   } else {
  //     return AuthService._logout();
  //   }
  // }

  // private static _logout() {
  //   if (localStorage.getItem(constants.localStorageUserLoginKey)) {
  //     localStorage.removeItem(constants.localStorageUserLoginKey);
  //     EmitterUtil.get(constants.events.navigation).emit(constants.pageUrl.login);
  //     return true;
  //   }
  //   return false;
  // }

  // public static isAuthenticated(): boolean {

  //   const loginUser = AuthService.getLoginUser();
  //   if (loginUser) {
  //     const jwtHelper = new JwtHelperService();
  //     const token = loginUser.token;
  //     if (!loginUser.token || jwtHelper.isTokenExpired(token)) {
  //       AuthService.logout();
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   }
  //   return false;
  // }


  // public static getToken(): string {

  //   if (AuthService.isAuthenticated()) {
  //     return AuthService.getLoginUser().token;
  //   }

  //   return '';
  // }

  // public static isLoginFromGoogle(): boolean {

  //   const loginUser = AuthService.getLoginUser();
  //   if (!AppUtils.isUndefinedOrNull(loginUser)) {
  //     return loginUser.googleLogin;
  //   }

  //   return false;
  // }

  // public static updateToken(token: string): string {

  //   if (token !== null) {
  //     if (AuthService.isAuthenticated()) {
  //       const loginUser = AuthService.getLoginUser();
  //       loginUser.token = token;
  //       localStorage.setItem(constants.localStorageUserLoginKey, JSON.stringify(loginUser));
  //       return AuthService.getLoginUser().token;
  //     }
  //   }
  // }

  /**************************
   * HELPER FUNCTIONS ********
   **************************/

   public static getToken(){
    const storedLoginUserToken = JSON.parse(localStorage.getItem("token"));
    return storedLoginUserToken ? storedLoginUserToken : null;
   }

  public static getLoggedInUser() {
    const storedLoginUser = JSON.parse(localStorage.getItem("currentUser"));
    return storedLoginUser ? storedLoginUser : null;
  }

  public static getLoggedInCurrentBranch() {
    const storedLoginBranch = JSON.parse(localStorage.getItem("currentBranch"));
    return storedLoginBranch ? storedLoginBranch : null;
  }


  public static getLoggedInCompany() {
    const loggedInUser = this.getLoggedInUser();
    return loggedInUser.company;
  }

  public static getLoggedInBranch() {
    const loggedInUser = this.getLoggedInUser();
    return loggedInUser.branch;
  }

  public static getLoggedInCompanyBranch() {
    const loggedInCompany = JSON.parse(localStorage.getItem("currentCompany"));
    return loggedInCompany;
  }

  public static getLoggedInUserId() {
    const loggedInUser = this.getLoggedInUser();
    return loggedInUser._id;
  }

  public static getLoggedInRole() {
    const loggedInUserRole = JSON.parse(localStorage.getItem("currentRole"));
    return loggedInUserRole;
  }

  // private buildLoginUser(token: any, data: any): LoginUser {
  //   data = data.data;
  //   const decodedToken: any = this.jwtHelper.decodeToken(token);
  //   const loginUser = new LoginUser(
  //     decodedToken.id,
  //     decodedToken.version,
  //     decodedToken.firstName,
  //     decodedToken.lastName,
  //     data.companyName,
  //     decodedToken.email,
  //     data.phone,
  //     decodedToken.exp,
  //     token,
  //     (data.gmailId) ? true : false,
  //     data.role,
  //     {},
  //     data.telephonicId,
  //     data.telephonicCode,
  //     data.parentid,
  //     data.customize
  //   );

  //   return loginUser;
  // }

  constructor(private http: HttpClient, private route: Router) {
    // this.loginUser = AuthService.getLoginUser();
  }

  // login(userId: string, data: any) {
  //   const url = constants.apiUrl.consumerLogin.replace('{userId}', userId);
  //   return this.http.post(url, JSON.stringify(data), {observe: 'response'})
  //     .pipe(map((response) => {
  //       //this.addLoginUserInLocalStorage(response);
  //       return response;
  //     }),
  //       catchError((error: any) => {
  //         return observableThrowError(error);
  //       }));
  // }

  // addLoginUserInLocalStorage(response) {
  //   const headers = response.headers;
  //   const token = headers.get(constants.apiRequestHeaderKeys.authToken);

  //   const loggedInContact = this.buildLoginUser(token, response.body);
  //   localStorage.setItem(constants.localStorageUserLoginKey, JSON.stringify(loggedInContact));
  // }

  // public static updateUserInfo(data: any) {
  //   let loggedInContact: LoginUser = AuthService.getLoggedInUser();
  //   loggedInContact.phone = data.phone;
  //   loggedInContact.firstName = data.firstName;
  //   loggedInContact.lastName = data.lastName;
  //   loggedInContact.companyName = data.companyName;
  //   loggedInContact.customize = data.customize;

  //   localStorage.setItem(constants.localStorageUserLoginKey, JSON.stringify(loggedInContact));
  // }

  // updateToken() {
  //   return this.http.get(constants.apiUrl.refreshToken)
  //     .pipe(map((response) => {
  //       return response;
  //     }),
  //       catchError((error: any) => {
  //         return observableThrowError(error);
  //       }));
  // }

  // sendForgot(email: string, parentId: string) {
  //   const requestUrl = constants.apiUrl.sendForgot.replace('{email}', email).replace('{parentId}', parentId);
  //   return this.http.get(requestUrl);
  // }

  // forgotPasswordVerify(token: string, parentId: string, password: string) {
  //   const requestUrl = constants.apiUrl.forgotPasswordVerify.replace('{password}', password).replace('{parentId}', parentId)
  //     .replace('{token}', token);
  //   return this.http.get(requestUrl, {observe: 'response'})
  //     .pipe(map((response) => {
  //       this.addLoginUserInLocalStorage(response);
  //       return response.body;
  //     }),
  //       catchError((error: any) => {
  //         return observableThrowError(error);
  //       }));
  // }

  // googleLogin(data: any) {
  //   return this.http.post(constants.apiUrl.gmailLogin, JSON.stringify(data), {observe: 'response'})
  //     .pipe(map((response) => {

  //       const headers = response.headers;
  //       const token = headers.get(constants.apiRequestHeaderKeys.authToken);

  //       //this.addLoginUserInLocalStorage(response);
  //       const loggedInContact = this.buildLoginUser(token, response.body);
  //       localStorage.setItem(constants.localStorageUserLoginKey, JSON.stringify(loggedInContact));
  //       return loggedInContact;
  //     }),
  //       catchError((error: any) => {
  //         return observableThrowError(error);
  //       }));
  // }

  // resendVerify(userId: string) {
  //   const url = constants.apiUrl.resendVerify.replace('{userId}', userId);
  //   return this.http.get(url)
  //     .pipe(map((response) => {
  //       return response;
  //     }),
  //       catchError((error: any) => {
  //         return observableThrowError(error);
  //       }));
  // }

  // VerifyUser(tokenId: string, parentId: string, password: string) {
  //   const url = constants.apiUrl.verify.replace('{token}', tokenId).replace('{parentId}', parentId)
  //     .replace('{password}', password);
  //   return this.http.get(url, {observe: 'response'})
  //     .pipe(map((response) => {
  //       this.addLoginUserInLocalStorage(response);
  //       return response.body;
  //     }),
  //       catchError((error: any) => {
  //         return observableThrowError(error);
  //       }));
  // }

  // confirmUser(tokenId: string, parentId: string) {
  //   const url = constants.apiUrl.confirm.replace('{token}', tokenId).replace('{parentId}', parentId);
  //   return this.http.get(url, {observe: 'response'})
  //     .pipe(map((response) => {
  //       this.addLoginUserInLocalStorage(response);
  //       return response.body;
  //     }),
  //       catchError((error: any) => {
  //         return observableThrowError(error);
  //       }));
  // }



}
